import React from 'react';
import '../css/workflowCard.css';

/* ── Props ────────────────────────────────────────────────────────────────── */

export interface WorkflowCardProps {
  label:       string;
  value:       number;
  color:       string;
  gradient:    string;
  borderColor: string;
  iconSrc:     string;
  iconAlt?:    string;
  backgroundColor?: string;
}

/* ── Component ────────────────────────────────────────────────────────────── */

const WorkflowCard: React.FC<WorkflowCardProps> = ({
  label,
  value,
  color,
  gradient,
  borderColor,
  iconSrc,
  iconAlt = '',
  backgroundColor
}) => (
  <div
    className="scl--cms-components-workflowCard"
    style={{ borderLeftColor: borderColor, background: backgroundColor }}
  >
    {/* Gradient icon badge containing the PNG */}
    <div
      className="scl--cms-components-workflowCard-icon"
      style={{ background: gradient }}
    >
      <img
        src={iconSrc}
        alt={iconAlt}
        className="scl--cms-components-workflowCard-iconImg"
      />
    </div>

    {/* Status label */}
    <span
      className="scl--cms-components-workflowCard-label"
      style={{ color }}
    >
      {label}
    </span>

    {/* Large numeric count */}
    <span
      className="scl--cms-components-workflowCard-value"
      style={{ color }}
    >
      {value}
    </span>
  </div>
);

export default WorkflowCard;